<template>
    <b-modal v-model="show" :title="$t('auto.carCategory.category') + '  '+$t('auto.carCategory.add')"
             :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group">
                        <label>{{$t('auto.carCategory.category')}}<span
                                class="red">*</span></label>
                        <input type="text" class="form-control" v-model="carCategory.name"
                               :class="{invalid : $v.carCategory.name.$error}"/>
                        <div class="red" v-if="$v.carCategory.name.$error">
                            {{$t('auto.carCategory.error')}}
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required} from 'vuelidate/lib/validators'

    export default {
        name: "CarCategoryModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                carCategory: {
                    name: null,
                },
                taxTypes: [],
            }
        },
        validations: {
            carCategory: {
                name: {
                    required: required
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },

            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                vm.carCategoryDto = {};
                this.processing = true;
                this.$http.post('/car-category/save', this.carCategory)
                    .then(res => {
                            if (res && res.data && res.data.status === 'SUCCESS') {
                                vm.show = false;
                                vm.carCategoryDto.id = res.data.data.id;
                                vm.carCategoryDto.name = res.data.data.text;
                                vm.carCategoryDto.status = true;
                                this.$eventBus.$emit('AutoTypeValueByType', vm.carCategoryDto, 'Category');
                            } else {
                                vm.show = false;
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.carCategory.name + '\n' + res.data.message,
                                    type: 'warning'
                                });
                            }

                            this.processing = false;
                        }
                    ).catch(error => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.common.errorOccurred') + '\n' + error.response.data.message,
                        type: 'error'
                    });
                    this.processing = false;
                });

            },
        },
        created() {
            this.$eventBus.$on('showCarCategoryModal', () => {
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>